<small class="debug">{{me}}</small>
<div style="position: relative">
  <img lazyImage [ngStyle]="{'opacity': enabled ? 1 : 0.2}" class="border-snap center-block" style="width: 229px; height: 130px"
    [loadingImage]="'./assets/images/screen_loading.gif'"
    [defaultImage]="'./assets/images/screen.png'"
    [errorImage]="'./assets/images/screen_error.png'"
    [retry]="8"
    [delay]="1500"
    (dblclick)="onMaximize()"
    (loaded)="_onLoaded()"
    (errored)="_onError()"
    (completed)="_onCompleted()">
    @if (showEnlarge) {
      <div class="showEnlarge">
        <mat-icon (click)="onMaximize()">fullscreen</mat-icon>
      </div>
    }
  </div>
  <ng-template let-modal #dialogScreenShot>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
      <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
      <div class="closeSnap">
        <button (click)="onCloseLargeSnapView()" mat-button>
          <mat-icon>close</mat-icon>
        </button>
        <mat-label style="padding-left: 10px">scale: {{snapScale * 100}}%</mat-label>
      </div>
    </h1>
    <div mat-dialog-content>
      <div class="helper-image">
        <img style="width: 100%; height: 100%" [src]="screenshotFullUrl"/>
      </div>
    </div>
  </ng-template>
